import styled from 'styled-components/macro';

import { Box } from '@olist/united';

export const Wrapper = styled(Box).attrs({
  mx: '-5px',
  mt: [-6, 'unset'],
  mb: 6,
  pt: [6, '20px'],
  px: '5px',
  pb: 2,
})`
  overflow: hidden;
`;
